import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

import ConnectionsMobileSubnav from './ConnectionsMobileSubnav';
import SectionBreadcrumb from '../../../_molecules/SectionBreadcrumb';
import SectionBreadcrumbs from '../../../_molecules/SectionBreadcrumbs';
import SectionHeader from '../../../_molecules/SectionHeader';
import ErrorHandler from '../../../_molecules/ErrorHandler';
import TrackPageView from '@tracking/TrackPageView';
import SearchMyMemberMatches from '../../../searches/SearchMyMemberMatches';
import LoadingArea from '@molecules/LoadingArea';
import { SectionWrapperInner, SectionWrapperOuter } from '@styled';

import useSavedSearches from '../../../../hooks/useSavedSearches';
import { SearchModeContext } from '../../../../../../algolia-search/js/context/searchContext'; // TODO: Cross module - consider moving this to shared
import useDocumentTitle from '@hooks/useDocumentTitle';

const getShowMatchCriteriaPageTitle = savedSearch => {
    let title = 'Saved Search';

    if (savedSearch?.title) {
        title = savedSearch.title;
    }

    if (!savedSearch?.title && savedSearch?.default && savedSearch?.primaryInterest) {
        title = `DEFAULT - ${savedSearch.primaryInterest.toUpperCase()}`;
    }

    return title;
};

export const ShowMatchCriteriaPage = () => {
    const [savedSearch, setSavedSearch] = useState();
    const { id: searchId } = useParams();
    const { loading: savedSearchesLoading, error: savedSearchesError } = useSavedSearches({
        onCompleted: ({ savedSearches }) => {
            setSavedSearch(savedSearches.find(search => search.id === searchId) || null);
        },
    });
    const title = getShowMatchCriteriaPageTitle(savedSearch);
    useDocumentTitle('Show Match Criteria');

    if (savedSearchesError) {
        throw savedSearchesError;
    }

    if (savedSearchesLoading || !savedSearch) {
        return <LoadingArea />;
    }

    return (
        <ErrorHandler>
            <TrackPageView>
                <ConnectionsMobileSubnav />

                <SectionWrapperOuter>
                    <SectionWrapperInner className="fade-in-fast">
                        <SectionHeader title="My ICSC Connections" />

                        <SectionBreadcrumbs className="mt-2">
                            <SectionBreadcrumb route="/my-icsc/connections">Connections</SectionBreadcrumb>
                            <SectionBreadcrumb route="/my-icsc/connections/matches">My Matches</SectionBreadcrumb>
                            <SectionBreadcrumb isActive>{title}</SectionBreadcrumb>
                        </SectionBreadcrumbs>

                        <h1 className="mt-2 mb-3">{title}</h1>
                        <p>These ICSC members meet your match criteria</p>
                        <div className="mt-4">
                            {savedSearch && (
                                <SearchModeContext.Provider value={{ showFilters: false }}>
                                    <SearchMyMemberMatches
                                        defaultViewType="card"
                                        parentView="Connections"
                                        savedSearch={savedSearch}
                                    />
                                </SearchModeContext.Provider>
                            )}
                        </div>
                    </SectionWrapperInner>
                </SectionWrapperOuter>
            </TrackPageView>
        </ErrorHandler>
    );
};
